import * as React from "react";
import { PivotReason, selectInsuranceProduct, } from "../../../../features/applicant/applicantSlice";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import { UnlinkedApplicationStatus, setPostedCompletedApplication, updateStatus, } from "../../../../features/unlinked-application/unlinkedApplicationSlice";
import { completedAutoUnlinkedApplication, completedUnlinkedApplication, } from "../../../../lib/Avo";
import { InsuranceProducts } from "../../../../constants";
import { QueryStatus } from "@reduxjs/toolkit/query";
import UnlikedApplicationPolicyHolderResidenceStatus from "./residence-status";
import UnlinkedApplicationAutoPolicyHolderContinuouslyInsured from "./continuously-insured";
import UnlinkedApplicationAutoPolicyHolderPolicyTenure from "./policy-tenure";
import UnlinkedApplicationPolicyHolder from "../../../../features/unlinked-application/routes/policy-holder";
import UnlinkedApplicationPolicyHolderMailingAddress from "./mailing-address";
import UnlinkedApplicationPolicyHolderNameAndDob from "./name-and-dob";
import useAppDispatch from "../../../../hooks/useAppDispatch";
import useAppSelector from "../../../../hooks/useAppSelector";
import { useEffectOnceWhen } from "rooks";
import useHandlePolicyOnly from "../../../../hooks/useHandlePolicyOnly";
import useMemoryHistory from "../../../../hooks/useMemoryHistory";
import usePostUnlinkedAccount from "../../../../services/savvy/usePostUnlinkedAccount";
import useUnlinkedApplicationCompleteNextRoute from "../../../../features/unlinked-application/useUnlinkedApplicationCompleteNextRoute";
export function UnlinkedApplicationAutoPolicyHolder() {
    var status = useAppSelector(function (state) { return state.unlinkedApplication; }).status;
    var dispatch = useAppDispatch();
    var _a = usePostUnlinkedAccount(), postUnlinkedAccount = _a.postUnlinkedAccount, isLoading = _a.status.isLoading, accountReferenceIdStatus = _a.accountReferenceIdStatus;
    var push = useMemoryHistory().push;
    var nextRoute = useUnlinkedApplicationCompleteNextRoute();
    var isBundleAutoFromHome = useAppSelector(function (state) {
        return state.applicant.bundlePivotReason === PivotReason.BundleAutoFromHome;
    });
    var commonAnalyticsProperties = useAppSelector(function (state) { return state.analytics.commonAnalyticsProperties; });
    var _b = React.useState(false), shouldWaitOnAccountRefId = _b[0], setShouldWaitOnAccountRefId = _b[1];
    var policyOnly = useAppSelector(function (state) { return state.configuration; }).policyOnly;
    var handlePolicyOnly = useHandlePolicyOnly();
    var disableSubmitButton = isLoading || shouldWaitOnAccountRefId;
    function handleSubmit() {
        if (isBundleAutoFromHome) {
            dispatch(selectInsuranceProduct({
                product: InsuranceProducts.AutoHome,
                changeRoute: false,
            }));
        }
        if (accountReferenceIdStatus === QueryStatus.pending) {
            setShouldWaitOnAccountRefId(true);
        }
        else {
            dispatch(updateStatus({ auto: UnlinkedApplicationStatus.Complete }));
        }
    }
    useEffectOnceWhen(function () {
        dispatch(updateStatus({ auto: UnlinkedApplicationStatus.Complete }));
    }, shouldWaitOnAccountRefId &&
        accountReferenceIdStatus === QueryStatus.fulfilled);
    useEffectOnceWhen(function () {
        postUnlinkedAccount(function (accountReferenceId) {
            dispatch(setPostedCompletedApplication({ auto: true }));
            completedUnlinkedApplication(commonAnalyticsProperties);
            completedAutoUnlinkedApplication(commonAnalyticsProperties);
            if (policyOnly) {
                handlePolicyOnly({ accountReferenceId: accountReferenceId });
            }
            else {
                push(nextRoute);
            }
        }, true);
    }, status.auto === UnlinkedApplicationStatus.Complete);
    return (React.createElement(UnlinkedApplicationPolicyHolder, { disableSubmitButton: disableSubmitButton, onSubmit: handleSubmit }));
}
export default function UnlinkedApplicationPolicyHolderRoutes() {
    var path = useRouteMatch().path;
    return (React.createElement(Switch, null,
        React.createElement(Route, { exact: true, path: path },
            React.createElement(UnlinkedApplicationAutoPolicyHolder, null)),
        React.createElement(Route, { path: path + "/mailing-address", component: UnlinkedApplicationPolicyHolderMailingAddress }),
        React.createElement(Route, { path: path + "/residence-status", component: UnlikedApplicationPolicyHolderResidenceStatus }),
        React.createElement(Route, { path: path + "/continuously-insured" },
            React.createElement(UnlinkedApplicationAutoPolicyHolderContinuouslyInsured, null)),
        React.createElement(Route, { path: path + "/policy-tenure" },
            React.createElement(UnlinkedApplicationAutoPolicyHolderPolicyTenure, null)),
        React.createElement(Route, { path: path + "/name-and-dob" },
            React.createElement(UnlinkedApplicationPolicyHolderNameAndDob, null))));
}
